import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { instance, pathname } from "./ActionCreators";
import axios from "axios";
import notifySuccess from "../../utils/Notifications/Success";
import error from "../../utils/Notifications/Error";
import { applyTicker } from "./GroupsSlice";
import { RootGetState } from "../store";
import checkSettingBeforeSet from "../../utils/checkSettingBeforeSet";
import TPH, { TradeParamsRequest } from 'utils/trade-params-handler';
import { compareObjects } from "utils/compareObjects";

type SettingsItem = [
    string[],
    string[]
]

export type MdpArr = [string, string, string, string, string]

type MdpType = {
    params: string[]
    values: MdpArr[]
}

const defaultSets = {
    "CP": [
        [
            "",
            "ID.depend",
            "Cotir.def.param.group.ID",
            "BidUncrossOffset",
            "AskUncrossOffset",
            "VolumeWeight",
            "NoVolumePenalty",
            "D.Spread",
            "NormalSpread",
            "QuoteVolume",
            "D_oc",
            "GO.HardOpen",
            "moveVol",
            "movePrice",
            "eLimitedMargin",
            "BUY",
            "SprOpen",
            "SprClose",
            "StepPos",
            "StepSpread",
            "NoShiftLimit",
            "LimitBuy",
            "SELL",
            "SprOpen",
            "SprClose",
            "StepPos",
            "StepSpread",
            "NoShiftLimit",
            "LimitSell",
            "HEDGING",
            "IsHedgeble",
            "Priority",
            "MinPos",
            "OrderVol",
            "PriceDistance",
            "SpreadCoefDistance",
            "UseTeorPrices",
            "HedgeInstId"
        ],
        [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            ""
        ]
    ],
    "MDP": {
        "params": [
            "SheduleID",
            "ID.depend",
            "ID.source",
            "Source.Type",
            "Source.type.shedule.ID",
        ],
        "values": []
    },
    "SP": [
        [
            "ID.source",
            "Source.def.par.group.ID",
            "DealsWindow..sec.",
            "DealsVolRecalcShare",
            "Currency",
            "ShortBonus",
            "NotTradable",
            "Factor",
            "Beta",
            "BaseInstr"
        ],
    ]
}

export type SettingsParamType = 'String' | 'Boolean' | 'Float' | 'Integer';
export type ParamGroupType = 'CP' | 'SP' | 'MDP';
export interface SavedSettingsItemAffiliation {
    group_name: string
    ticker_name: string
    exchange_name: string
}

export interface SavedSattingsItemAbstract {
    key: string
    value: any
    type?: SettingsParamType
    has_change?: boolean
    source?: string
}

export interface SavedSettingsItem extends SavedSattingsItemAbstract {
    affiliation: SavedSettingsItemAffiliation
}

export type SavedCPSettingsState = {
    [id: string]: SavedSettingsItem[]
}

export type SavedSettingsState = SavedSettingsItem[];
export type SavedSettingsDefaults = {
    [key in ParamGroupType]: SavedSettingsItem[]
}
export type SelectedMDPState = {
    [group_name: string]: {
        [ticker_name: string]: {
            [exchange_name: string]: {
                
            }
        }
    }
}

type SettingsState = {
    saved_CP_settings: SavedCPSettingsState
    settings_defaults: SavedSettingsDefaults
    memorized_settings: SavedSettingsItem[]
    from_sp: any[]
    saved_settings: SavedSettingsState
    loading: boolean
    error: null | string | { block: string }
    isReset: boolean
    resetKey: number
    searchString: string
    mdpPage: number
    totalSPPages: number
    isMore: boolean
    SPTypes: object
    CPTypes: object
    MDPTypes: Array<string>
    MDPSelectedItem: { SPname: string }
    activeGroup: { name: string, id?: number }
    activeTicker: { name: string, isNew: boolean }
    allSP: Array<string>
    nativeSP: Array<string>
    isChanged: boolean
    isNewTickerAdding: boolean
    settings: {
        CP: SettingsItem,
        MDP: MdpType,
        SP: Array<string[]>,
    },
    savedSettings: {
        CP: SettingsItem,
        MDP: MdpType,
        SP: Array<string[]>,
    },
    defaultSets: {
        CP: SettingsItem,
        MDP: MdpType,
        SP: Array<string[]>,
    },

}

const initialState: SettingsState = {
    saved_CP_settings: {},
    memorized_settings: [],
    settings_defaults: {
        MDP: [],
        SP: [],
        CP: []
    },
    from_sp: [],
    saved_settings: [],
    loading: false,
    error: null,
    isReset: true,
    resetKey: 0,
    searchString: "",
    totalSPPages:2,
    mdpPage: 1,
    isMore: true,
    isChanged: false,
    isNewTickerAdding: false,
    MDPSelectedItem: { SPname: "" },
    activeGroup: { name: "Группа", id: -1 },
    activeTicker: { name: "Название тикера", isNew: false },
    allSP: [],
    SPTypes: {},
    CPTypes: {},
    MDPTypes: [],
    nativeSP: [],
    settings: {
        CP: [
            [], []
        ],
        MDP: {
            params: [] as string[],
            values: [
                ['', '', '', '', '']
            ]
        },
        SP: [],
    },
    savedSettings: {
        CP: [
            [], []
        ],
        MDP: {
            params: [] as string[],
            values: [
                ['', '', '', '', '']
            ]
        },
        SP: [],
    },
    defaultSets: {
        CP: [
            defaultSets.CP[0], defaultSets.CP[1]
        ],
        MDP: {
            "params": defaultSets.MDP.params,
            "values": defaultSets.MDP.values
        },
        SP: [
            defaultSets.SP[0]
        ],
    },

}

const TEMPLATE_GROUP_NAME = 'template'

export const getMDP = createAsyncThunk('get/mdp',
    async (_, { dispatch }) => {
        const response = await instance.get(`${pathname}api/mdp-parameters`);
        return response.data;
})

export const downloadLogsFile = createAsyncThunk('get/logs-file',
    async ({ link }: { link: string }, { rejectWithValue, dispatch, getState }) => {
        const response = await instance.get(`${pathname}${link.replace('media', 'api')}`);
        const file_name = link.split('/')[link.split('/').length - 1];

        if (response?.data) {
            const split = link.split('/');
            const file = split[split.length - 1];
            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );
            const file_link = document.createElement('a');
            file_link.href = url;
            file_link.setAttribute('download', file);
            document.body.appendChild(file_link);
            file_link.click();
        }
        if (response?.data === '') {
            error(`Файл ${file_name} пустой`);
        }
        return response.data;
    }
)

export const updateTickerSettings = createAsyncThunk('post/ticker',
    async ({ body, notify }: { body: TradeParamsRequest, notify?: boolean }, { rejectWithValue, dispatch }) => {
        let response;
        try {
            response = await instance.post(pathname + 'api/ticker', body)
            notifySuccess('Настройки тикера успешно сохранены')
        }
        catch(err) {
            error(`Ошибка: ${err.response?.status}`);
            dispatch(getTickerSettings());
        }
        if (notify !== false) {
            dispatch(applyTicker(null));
        }
        dispatch(getTickerSettings());
        return response.data;
    }
)

export const getMDPParams = createAsyncThunk('get/Params',
    async ({ group_name, page, search }: { group_name: string, page: number, search: string },
        { rejectWithValue, dispatch }) => {
        let response;
        try {
            response = await instance.get(pathname + `api/ticker/${search}?group_name=${group_name}`);
        }
        catch(e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
        return response?.data;
    }
)

export const getSPParams = createAsyncThunk('get/SPParams',
    async (_, { rejectWithValue, }) => {
        try {
            const response = await instance.get(pathname + `api/sp-parameters`)
            TPH.param_types = response.data.map(x => ({
                key: x.name,
                type: x.type
            }));
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)
export const getCPParams = createAsyncThunk('get/CPParams',
    async (_, { rejectWithValue, }) => {
        try {
            const response = await instance.get(pathname + `api/cp-parameters`)
            TPH.param_types = response.data.map(x => ({
                key: x.name,
                type: x.type
            }));
            // isEqual(response.data)
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const getMDPSourceTypes = createAsyncThunk('get/MDPSourceTypes',
    async (_, { rejectWithValue, }) => {
        try {
            const response = await instance.get(pathname + `api/source-parameter`)
            // isEqual(response.data)
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const getTickerSettings = createAsyncThunk('get/tickerSettings',
    async (_, { rejectWithValue, getState, dispatch }) => {
        const { settings } = getState() as any
        const { activeTicker: ticker, activeGroup: group } = settings
        try {
            const response = await instance.get(pathname + `api/ticker/${ticker.name}?group_name=${group.name}`)
            // блокируем как только нас пустили для редактирования
            dispatch(
                changeTickerBlockStatus({
                    blockIt: true,
                    ticker: ticker.name,
                    group: group.name,
                })
            );
            dispatch(dropState({
                exclude_ticker: ticker.name
            }));
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)
export const setDefaultTickerSettings = createAsyncThunk('set/tickerDefaultSettings',
    async (_, { rejectWithValue, getState }) => {
        const { settings } = getState() as any
        const { activeTicker: ticker, } = settings
        try {
            // const some = await instance.get(pathname + `api/ticker/AA?group_name=default`)
            const localSets = {
                ...settings.defaultSets, CP: settings.defaultSets.CP.map((it, index) => {
                    if (index !== 1) {
                        return it
                    }
                    return it.map((it, index) => {
                        if (index !== 1) {
                            return it
                        }
                        return ticker.name + "~DEP~SPB"
                    })
                    
                })
            }
            // localSets.CP[1][1] = ticker.name + "~DEP~SPB"
            return localSets
        } catch (e: any) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const setTickerSettings = createAsyncThunk('set/tickerSettings',
    async ({ shouldApply = false }: { shouldApply?: boolean }, { rejectWithValue, getState, dispatch }) => {
        const { settings } = getState() as any
        const { activeTicker: ticker, activeGroup: group } = settings

        const isEmpty = settings.savedSettings.MDP.values.findIndex((item: string[]) => item[3] === "")
        // removing ::copy string if necessary
        const formatFromCopyMDPValues = settings.savedSettings.MDP.values?.map((tupleOfValues) => {
            tupleOfValues[2].replace("::copy", "")
            return tupleOfValues
        })
        let newMDP = [settings.savedSettings.MDP.params, ...formatFromCopyMDPValues]

        if (group.name === 'default') {
            newMDP = newMDP.map((item) => [...item.slice(0, item.length - 1)])
        }
         
        const [cpStatus, mdpStatus, spStatus] = checkSettingBeforeSet(settings.savedSettings.CP[1], newMDP, settings.savedSettings.SP.slice(1))
        if ([cpStatus, mdpStatus, spStatus].every(it => it.isValid)) {
            const body = {
                "group_name": group.name,
                "ticker_name": ticker.name,
                "CP": settings.savedSettings.CP,
                "MDP": [...newMDP],
                "SP": [...settings.savedSettings.SP]
            }

            if (isEmpty !== -1) {
                error("Не удалось сохранить. Пустые поля типа в MDP")
            } else {
                try {
                    const response = await instance.post(pathname + `api/ticker`, body)

                    if (response.data.hasOwnProperty("Предупреждение")) {
                        error(response.data["Предупреждение"])
                    } else {
                        notifySuccess('Настройки тикера успешно сохранены')
                        if (shouldApply) dispatch(applyTicker(null))
                        dispatch(getTickerSettings())
                        return response.data
                    }

                } catch (e) {
                    if (axios.isAxiosError(e)) {
                        error("Не удалось сохранить настройки")
                        console.error(e.message)
                        return rejectWithValue(e.message)
                    }
                }
            }
        } else {
            [cpStatus, mdpStatus, spStatus].map(item => {
                if (!item.isValid) error(item.message)
            })
        }

    }
)


export const getSPData = createAsyncThunk('get/SPData',
    async ({
               page = 1,
               search = "",
               isSame = false
           }: { page: number, search?: string, isSame: boolean }, { rejectWithValue, getState }) => {
        const { settings } = getState() as RootGetState

        const group = settings.activeGroup.name
        const searchString = search === "" ? settings.activeTicker.name : search

        if (!isSame) {
            try {
                const response = await instance.get(pathname + `api/sp?group_name=${group}&search=${searchString}`)
                return response.data
            } catch (e) {
                if (axios.isAxiosError(e)) {
                    return rejectWithValue(e.message)
                }
            }
        }
    }
)
export const getNativeSPData = createAsyncThunk('get/nativeSPData',
    async ({ search = "" }: { search?: string }, { rejectWithValue, getState }) => {
        const { settings } = getState() as RootGetState
        const group = settings.activeGroup.name
        // const activeGroup= "settings"
        try {
            const response = await instance.get(pathname + `api/sp?group_name=${group}&search=${search}`)
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
);

export const changeTickerBlockStatus = createAsyncThunk(
    "change/TickerBlockStatus",
    async (
        {
            blockIt,
            ticker,
            group,
        }: { blockIt: boolean; ticker: string; group: string },
        { rejectWithValue }
    ) => {
        const body = { group_name: group, ticker_name: ticker };
        const reqType = blockIt ? "block" : "unblock";
        try {
            const response = await instance.post(
                pathname + `api/${reqType}`,
                body
            );
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message);
            }
        }
    }
);

const settingsSlice = createSlice({
    name: 'SettingsSlice',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        memorizeParam(state, action) {
            state.memorized_settings.push(action.payload);
        },
        dropDraft(state) {
            state.saved_settings = state.saved_settings
                .map(x => {
                    if (x.has_change) {
                        const memorized_item = state.memorized_settings
                            .find(item => item.key === x.key &&
                                Object.keys(x?.affiliation)
                                    .every(key => x?.affiliation[key] === item?.affiliation[key])
                                );
                        if (memorized_item) {
                            return {
                                ...memorized_item,
                                has_change: false
                            };
                        }
                    }
                    return {
                        ...x,
                        value: '',
                        has_change: false
                    };
                });
            const CP_STATE = current(state.saved_CP_settings);
            for (const key of Object.keys(CP_STATE)) {
                if (Array.isArray(CP_STATE[key])) {
                    state.saved_CP_settings[key] = CP_STATE[key]
                        .map(x => {
                            if (x.has_change) {
                                const memorized_item = state.memorized_settings
                                .find(item => item.key === x.key && Object.keys(x.affiliation)
                                    .every(key => x.affiliation && item.affiliation && x?.affiliation[key] === item?.affiliation[key]));
                                if (memorized_item) {
                                    return {
                                        ...memorized_item,
                                        has_change: false
                                    };
                                }
                            }
                            return {
                                ...x,
                                has_change: false
                            };
                        });
                }
            }
            try {
              const hasMDPCahnges = !compareObjects(state.settings.MDP, state.savedSettings.MDP);
              if(hasMDPCahnges) {
                state.savedSettings.MDP = state.settings.MDP;
              }
            } catch (err) {
              console.error(err);
            }

        },
        dropState(state, action) {
            const { exclude_ticker } = action.payload;
            const MDP_STATE = current(state.savedSettings.MDP.values);
            const ACTIVE_MDP = [];
            for (const MDP of MDP_STATE) {
                const exchange_name = MDP[2];
                ACTIVE_MDP.push(exchange_name);
            }

            state.saved_settings = state.saved_settings.filter(x =>
                x?.affiliation?.ticker_name === exclude_ticker &&
                ACTIVE_MDP.includes(x?.affiliation?.exchange_name)
            );
            
            const CP_STATE = current(state.saved_CP_settings);
            for (const key of Object.keys(CP_STATE)) {
                if (Array.isArray(CP_STATE[key])) {
                    state.saved_CP_settings[key] = CP_STATE[key].filter(x => x?.affiliation?.ticker_name === exclude_ticker);
                }
            }
        },
        removeMDPItem(state, action) {
            const { mdp_name } = action.payload;
            state.savedSettings.MDP.values = state.savedSettings.MDP.values.filter(x => x[2] !== mdp_name);
            state.isChanged = true;
        },
        updateTickerName(state, action) {
            const {
                old_name,
                new_name
            } = action.payload;
            const CP_STATE = current(state.saved_CP_settings);
            state.saved_settings = state.saved_settings.map(x => {
                if (x?.affiliation && x.affiliation.ticker_name === old_name) {
                    return {
                        ...x,
                        affiliation: {
                            ...x.affiliation,
                            ticker_name: x.affiliation.ticker_name.replace(old_name, new_name)
                        }
                    };
                }
                return x;
            });
            for (const key of Object.keys(CP_STATE)) {
                state.saved_CP_settings[key] = CP_STATE[key].map(x => {
                    if (x?.affiliation && x.affiliation.ticker_name === old_name) {
                        return {
                            ...x,
                            affiliation: {
                                ...x.affiliation,
                                ticker_name: x.affiliation.ticker_name.replace(old_name, new_name)
                            }
                        };
                    }
                    return x;
                })
            }
        },
        resetTicker(state, action) {
            const { ticker_name } = action.payload;
            state.saved_settings = state.saved_settings.filter(x => x.affiliation && x.affiliation.ticker_name !== ticker_name);
            const CP_STATE = current(state.saved_CP_settings);
            const new_cp = {...Object.keys(CP_STATE).map(key => ({
                [key]: CP_STATE[key].filter(x => x.affiliation && x.affiliation.ticker_name !== ticker_name)
            }))};
            //@ts-ignore
            state.saved_CP_settings = new_cp;
            state.savedSettings = initialState.savedSettings
            state.MDPSelectedItem = initialState.MDPSelectedItem
            state.activeTicker = initialState.activeTicker
            state.settings = initialState.settings
            state.nativeSP = initialState.nativeSP
            state.allSP = initialState.allSP
            state.isChanged = false
            state.isNewTickerAdding = false
            state.resetKey += 1
            state.from_sp = []

        },
        removeCPSettingsItem(state, action) {
            const {
                id,
                key
            } = action.payload;
            state.saved_CP_settings[id] = state.saved_CP_settings[id].filter(x => x.key !== key);
        },
        saveCPSettingsItem(state, action) {
            const {
                id,
                key,
                value,
                affiliation,
                has_change
            }: {
                id: string
                key: string
                value: string
                has_change?: boolean
                affiliation: SavedSettingsItemAffiliation
            } = action.payload;

            let hasChangeValue = typeof has_change === 'boolean' ? has_change : true; 

            try {
              const memorized_item = state.memorized_settings
              .find(item => item.key === key && Object.keys(affiliation)
                  .every(key => affiliation && item.affiliation && affiliation[key] === item?.affiliation[key]));
              hasChangeValue = memorized_item.value !== value;
            } catch (err) {
              console.error(err);
            }

            const CP_STATE = current(state.saved_CP_settings);
            const place = CP_STATE[id];
            const item = {
                key,
                value,
                affiliation,
                has_change: hasChangeValue
            };
            if (!Array.isArray(place)) {
                state.saved_CP_settings[id] = [item];
                return;
            }
            const index = place.findIndex(x => x.key === key);
            if (index !== -1) {
                state.saved_CP_settings[id][index] = item;
                return;
            }
            state.saved_CP_settings[id].push(item);
        },
        saveSettingsItem(state, action) {
            const {
                exchange_name,
                key,
                value,
                affiliation
            } = action.payload;
            const _state = current(state.saved_settings);
            const settings_item = {
                key,
                value,
                affiliation,
                has_change: true
            };
            state.isChanged = true;
            const found_item_index = _state.findIndex(x => {
                if (!x.affiliation) {
                    return false;
                }
                const keys = Object.keys(x.affiliation);
                if (
                    x.key === key &&
                    keys.every(key => x.affiliation[key] === affiliation[key])
                ) {
                    return true;
                }
            });

            if (found_item_index !== -1) {
                state.saved_settings[found_item_index] = settings_item;
                return;
            }

            state.saved_settings.push(settings_item);
        },
        resetState: () => initialState,
        resetSavedCPSettings: (state) => {
            const newCpSettings = JSON.parse(JSON.stringify(state.saved_CP_settings))

            for (let listOfSetting of Object.keys(newCpSettings)) {
                newCpSettings[listOfSetting] = newCpSettings[listOfSetting].map((settings) => {
                    return {...settings, value: ""}
                })
            }

            state.saved_CP_settings = newCpSettings    

            state.memorized_settings = state.memorized_settings.map((settings) => {
                return {...settings, value: ""}
            })
        },
        resetSp(state) {
            state.allSP = initialState.allSP
            // state.searchString = ""
            state.mdpPage = 1
        },
        resetTickerSettings(state) {
            state.savedSettings = initialState.savedSettings
            state.MDPSelectedItem = initialState.MDPSelectedItem
            // state.searchString = ""
            state.activeTicker = initialState.activeTicker
            state.settings = initialState.settings
            state.nativeSP = initialState.nativeSP
            state.allSP = initialState.allSP
            state.isChanged = false
            state.isNewTickerAdding = false
            state.resetKey += 1
        },
        resetGroup(state) {
            state.activeGroup = initialState.activeGroup
            state.savedSettings = initialState.savedSettings
            state.MDPSelectedItem = initialState.MDPSelectedItem
            // state.searchString = ""
            state.activeTicker = initialState.activeTicker
            state.settings = initialState.settings
            state.nativeSP = initialState.nativeSP
            state.allSP = initialState.allSP
            state.isChanged = false
            state.isNewTickerAdding = false
            state.resetKey += 1
        },

        setIsReset(state, action) {
            state.isReset = action.payload
            state.resetKey += 1
            state.isChanged = false

        },
        setSearchString(state, action) {
            state.searchString = action.payload
            state.mdpPage = 1
        },
        setPage(state, action) {
            state.mdpPage = action.payload
        },
        setTotalSPPages(state, action) {
            state.totalSPPages = action.payload
        },
        setIsMore(state, action) {
            state.isMore = action.payload
        },
        setMDPSelectedItem(state, action) {
            state.MDPSelectedItem = action.payload
        },
        setSelectedGroup(state, action) {
            state.activeGroup = action.payload
            state.MDPSelectedItem = initialState.MDPSelectedItem
        },
        setSelectedTicker(state, action) {
            state.activeTicker.name = action.payload.name
            state.activeTicker.isNew = !!action.payload.isNew
            state.MDPSelectedItem = initialState.MDPSelectedItem

            state.isChanged = false
        },
        setSavedCP(state, action) {
            state.isChanged = true
            state.savedSettings.CP = action.payload;
        },
        setSavedSP(state, action) {
            state.isChanged = true
            state.savedSettings.SP = action.payload
        },
        resetSavedSP(state) {
            state.savedSettings.SP = state.settings.SP
        },

        setSavedMDP(state, action) {
            state.isChanged = true
            state.savedSettings.MDP = action.payload
        },

    },
    extraReducers: {
        [getMDP.fulfilled.type]: (state, action) => {
            const list = action.payload;
            const MDP = list.slice().map(x => x?.name);
            state.savedSettings.MDP = {
                params: MDP,
                values: []
            }
        },
        [getMDPParams.fulfilled.type]: (state, action) => {
            const { MDP, SP, CP } = action.payload;
            const cur = current(state.settings);
            const MDPSelectedItem = current(state.MDPSelectedItem);
            const activeGroup = current(state.activeGroup);
            const activeTicker = current(state.activeTicker);
            const min_exchange_length = 3;
            const defined = [];
            const casted_ = TPH.castCP(CP[0], CP[1]);
            const CP_STATE = current(state.saved_CP_settings);
            for (const key of Object.keys(CP_STATE)) {
                const place = CP_STATE[key];
                if (Array.isArray(place)) {
                    for (let x = 0; x < place.length; x ++) {
                        if (place.length < x) {
                            continue;
                        }
                        //state.saved_CP_settings[key][x] = casted_.find(item => item.key === CP_STATE[key][x].key);
                    }
                }
            }

            const is_exchange =
                (x) => typeof x === 'string' && x.length >= min_exchange_length && x.includes('~');

            const data = [];

            const setOfTheMDPNames = new Set()
            for (let x = 1; x < MDP.length; x ++) {
                const part = MDP[x].slice();
                // that need because we should have a diff between two "similar" params one of them will be the "name"
                // and another be the "name::copy"
                // this will be fixed later when we what to send this info on the server, so you don't need to be worry about it  
                if (setOfTheMDPNames.has(part[2])){
                    part[2] = part[2] + "::copy" 
                }
                setOfTheMDPNames.add(part[2])
                data.push(
                    ...part
                );
            }

            if (!Array.isArray(data)) {
                return;
            }
            for (const x of data) {
                if (is_exchange(x)) {
                    defined.push(x);
                }
            }

            state.from_sp = defined;

            if (!Array.isArray(SP)) {
                return;
            }
            const __casted = TPH.castSPData(SP);
            const __state = current(state.saved_settings);

            const to_state: SavedSettingsItem[] = [];
            const _affiliation = {
                group_name: activeGroup?.name,
                ticker_name: activeTicker?.name
            };
            for (const item of __casted) {
                if (
                    __state.some(x => {
                        if (
                            x.key === item.key &&
                            x.affiliation &&
                            Object.keys(_affiliation).every(key => _affiliation[key] === x.affiliation[key])
                        ) {
                            return true;
                        }
                        return false;
                    })
                ) {
                    continue;
                }
                
                const copy = JSON.parse(JSON.stringify(item));
                to_state.push({
                    ...copy,
                    affiliation: {
                        ...copy.affiliation,
                        ..._affiliation
                    }
                });
            }
            const required_fields = ['key'];
            const __saved_settings = to_state.filter(x => required_fields.every(key => typeof x[key] === 'string' && x[key].length));
            state.saved_settings = __saved_settings;
        },
        [getSPParams.fulfilled.type]: (state, action) => {
            const spHeaders = action.payload.map(i => i.name)
            state.defaultSets.SP[0] = spHeaders
            state.settings.SP[0] = spHeaders
            state.savedSettings.SP[0] = spHeaders
            state.SPTypes = Object.fromEntries(action.payload.map((i) => Object.values(i)))

            const _state = current(state);
            const selected_exchange = _state.MDPSelectedItem?.SPname;
            if (typeof selected_exchange === 'string') {
                const place = _state.saved_settings[selected_exchange];
                const items = [];
                const excluded_params = ['ID.source'];
                for (const x of action.payload) {
                    if (excluded_params.includes(x.name)) {
                        continue;
                    }
                    items.push({
                        key: x.name,
                        type: x.type,
                        value: ''
                    });
                }
                state.settings_defaults['SP'] = items;
            }
        },
        [getCPParams.fulfilled.type]: (state, action) => {
            const cpHeaders = action.payload.map((i): { name: string } => i.name)
            state.settings.CP[0] = cpHeaders
            state.savedSettings.CP[0] = cpHeaders
            state.defaultSets.CP[0] = cpHeaders
            state.defaultSets.CP[1] = Array(cpHeaders.length).fill("")
            state.CPTypes = Object.fromEntries(action.payload.map((i) => Object.values(i)))
        },
        [getMDPSourceTypes.fulfilled.type]: (state, action) => {
            state.MDPTypes = action.payload
        },
        [getTickerSettings.pending.type]: (state) => {
            state.loading = true
        },
        [getTickerSettings.rejected.type]: (state, action) => {
            state.loading = false;
            const error = action.payload;
            if (typeof error === "string") {
                state.error = "Ошибка!";
                return;
            }
            try {
                const user = error?.block[0].split('user ')[1]
                state.error = `Тикер занят пользователем ${user}`
            }
            catch(error) {
                console.error('catched error: ', error);
            }
        },
        [getTickerSettings.fulfilled.type]: (state, action) => {
            const { CP, MDP, SP } = action.payload
            
            const setOfTheMDPNames = new Set()
            const formatedMDP =  MDP.slice(1).map((tupleOfValues) => {
                // that need because we should have a diff between two "similar" params one of them will be the "name"
                // and another be the "name::copy"
                // this will be fixed later when we what to send this info on the server, so you don't need to be worry about it  
                const formatedTuple = tupleOfValues.slice()
                if (setOfTheMDPNames.has(formatedTuple[2])){
                    formatedTuple[2] = formatedTuple[2] + "::copy" 
                } else {
                    setOfTheMDPNames.add(formatedTuple[2])
                }
                return formatedTuple
            })

            state.loading = false
            state.error = null
            state.isNewTickerAdding = false
            state.settings.CP = CP
            state.savedSettings.CP = CP
            state.settings.MDP.params = MDP[0]
            state.savedSettings.MDP.params = MDP[0]
            state.settings.MDP.values = formatedMDP
            state.savedSettings.MDP.values = formatedMDP
            state.savedSettings.SP = SP
            state.settings.SP = SP;
            state.isChanged = false;
            const __state = current(state.saved_settings);
            const casted = TPH.castSPData(SP);
            const to_state = [];
            const affiliation = {
                ticker_name: state.activeTicker?.name,
                group_name: state.activeGroup?.name,
            };
            for (const item of casted) {
                const state_item = __state.find(x => x.key === item.key);
                if (
                    state_item &&
                    !to_state.find(x => x.key === state_item.key &&
                        Object.keys(x.affiliation).every(key => x.affiliation[key] === state_item.affiliation[key])
                    )
                ) {
                    to_state.push({
                        ...state_item,
                        value: item.value,
                        has_change: false
                    });
                }
            }
            const required_fields = ['key'];
            const __saved_settings = __state.map(item => {
                const new_item = to_state.find(x => x.key === item.key && Object.keys(x.affiliation).every(key => x.affiliation[key] === item.affiliation[key]));
                if (new_item) {
                    return new_item;
                }
                return {
                    ...item,
                    has_change: false
                };
            }).filter(x => required_fields.every(key => typeof x[key] === 'string' && x[key].length));
            
            const casted_ = TPH.castCP(CP[0], CP[1]);
            state.saved_settings = __saved_settings;
            //@ts-ignore
            const __items = [...casted, ...casted_].map(x => ({...x, affiliation: {...x?.affiliation, ...affiliation}}));
            //@ts-ignore
            state.memorized_settings = __items;
            const CP_STATE = current(state.saved_CP_settings);
            for (const key of Object.keys(CP_STATE)) {
                const current_state = CP_STATE[key];
                if (!Array.isArray(current_state)) {
                    continue;
                }
                for (let x = 0; x < current_state.length; x ++) {
                    const item = current_state[x];
                    if (
                        item.affiliation &&
                        Object.keys(affiliation).every(x => affiliation[x] === item.affiliation[x])
                        ) {
                            const __item = {
                                ...item,
                                has_change: false
                            }
                            state.saved_CP_settings[key][x] = __item;
                        }
                }
            }

        },
        [setDefaultTickerSettings.fulfilled.type]: (state, action) => {
            // const {CP, MDP, SP} = action.payload
            state.isChanged = true
            state.isNewTickerAdding = true
            state.loading = false
            state.error = null
            state.settings = action.payload
            state.savedSettings = action.payload

        },
        [getSPData.fulfilled.type]: (state, action) => {
            const payData = action.payload.data
            state.mdpPage = action.payload.current_page_number
            state.allSP = payData
            state.totalSPPages = action.payload.total_pages
            // state.settings.SP.push(...filtered.slice(1))
        },
        [getNativeSPData.fulfilled.type]: (state, action) => {
            const payData = action.payload.data
            state.allSP = payData
            const currentTicker = state.activeTicker
            state.nativeSP = payData.filter(spData => spData[0].startsWith(currentTicker)).map(spData => spData[0])
        },
        [setTickerSettings.fulfilled.type]: (state) => {
            state.isChanged = false
            state.isNewTickerAdding = false

        },
        [updateTickerSettings.fulfilled.type]: (state) => {
            state.isChanged = false
            state.isNewTickerAdding = false
        },


    }
});

export const {
    setTotalSPPages,
    setMDPSelectedItem,
    setSelectedGroup,
    setSelectedTicker,
    setIsReset,
    setSearchString,
    resetSp,
    setSavedCP,
    setSavedSP,
    setSavedMDP,
    setPage,
    setIsMore,
    resetTickerSettings,
    resetSavedSP,
    resetGroup,
    saveSettingsItem,
    saveCPSettingsItem,
    removeCPSettingsItem,
    removeMDPItem,
    resetTicker,
    updateTickerName,
    dropState,
    dropDraft,
    memorizeParam,
    setLoading,
    resetState,
    resetSavedCPSettings
} = settingsSlice.actions

export const hasChangesSelector = (state) => {
    const savedSettingsChanges = state.settings.saved_settings.map((x) => x.has_change).some(x => !!x);    
    const hasMDPCahnges = state.settings.settings.MDP.params.length > 0 && !compareObjects(state.settings.settings.MDP, state.settings.savedSettings.MDP);

    const CP_STATE = state.settings.saved_CP_settings;
    const savedCPSettingsChanges = Object.keys(CP_STATE).map((key) => {
        if (Array.isArray(CP_STATE[key])) {
            return CP_STATE[key].map((x) => x.has_change).some(x => x !== false);
        }
        return false;
    }).some(x => !!x);

    return savedSettingsChanges || savedCPSettingsChanges || hasMDPCahnges;
};

export default settingsSlice.reducer
